import httpClient from '../httpClient';


const getOffer =  () => httpClient.get('/MainPage/Offer/Get?page=1&pageSize=10000').then(
  (data) => data
)
  .catch(()=>{
    //
  })
const setOffer =  (params) => httpClient.post('/MainPage/Offer/Post', {

  file: params.imgPath,
  text: params.text
},{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })
const putOffer = (params,id) => httpClient.put(`/MainPage/Offer/PUT/${id}`, {
  id:id,
  file: params.imgPath,
  text: params.text},{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })


const  deleteOffer= (id) => httpClient.delete(`/MainPage/Offer/Delete/${id}`,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })
export {
  getOffer,
  setOffer,
  putOffer,
  deleteOffer
  // getUser,
  // createUser
}
